module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/kefu.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fkefu.png
// module id = 7j0y
// module chunks = 93